import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as jobRangeActions from '../actions/JobRanges';
import { setSelectedSort, updateFilteredModelJobs } from '../actions/modelDetails';
import { showSlideout } from '../../../Slideout/SlideoutReducer';
import { Link } from 'react-router-dom';
import { ReactReduxContext } from 'react-redux';
import { SLIDEOUTS } from '../../../Slideout/Slideouts';
import TextInputMP from '../../../TextInputMP/TextInputMP';
import ExpandableHeader from '../ExpandableHeader/ExpandableHeader';
import ModelJobsList from './ModelJobsList/ModelJobsList';
import LoadingIndicator from '../../../LoadingIndicator/LoadingIndicator';
import RangeChartList from './RangeChartList/RangeChartList';
import Dropdown from 'ps-components/Dropdown/Dropdown';
import FooterStatsBar from './FooterStatsBar/FooterStatsBar';
import capitalize from 'lodash/capitalize';
import Pagination from '../../../Pagination/Pagination';
import Search from '../../../Search/Search';
import classnames from 'classnames';
import './ModelDetailsPage.scss';
import ConfirmModal from './ConfirmModal/ConfirmModal';
import TableInfoList from '../../../TableInfoList/TableInfoList';
import { applyRounding, parseNumCheckNull, parseFloatCheckNull, numberWithCommas } from '../../../lib/formatters';
import {
  getCurrencies,
  getIsUserReadOnly,
  getSessionCurrency,
  getUseJobCodeKey,
  getReplacementTokens
} from '../../../redux/stateSelectors';
import { Select } from '../../../../ps-aspect-design';

import { BUILD_BY_PERCENTAGE, MARKET_RANGE_TYPE } from '../Utils/constants';

const SORT_OPTIONS = [
  { key: 'None', text: 'None' },
  { key: 'Job Title (ASC)', text: 'Job Title (ASC)' },
  { key: 'Job Title (DESC)', text: 'Job Title (DESC)' },
  { key: 'Job Code (ASC)', text: 'Job Code (ASC)' },
  { key: 'Job Code (DESC)', text: 'Job Code (DESC)' },
  { key: 'Job Code Key (ASC)', text: 'Job Code Key (ASC)' },
  { key: 'Job Code Key (DESC)', text: 'Job Code Key (DESC)' },
  { key: 'Job Family (ASC)', text: 'Job Family (ASC)' },
  { key: 'Job Family (DESC)', text: 'Job Family (DESC)' }
];


const propTypes = {
  nameInputValue: PropTypes.string,
  onNameInputChange: PropTypes.func,
  showEditJobRangeModel: PropTypes.bool,
  toggleEditJobRangesModel: PropTypes.func,
  addJobsToModelClick: PropTypes.func,
  showAddJobSlideOut: PropTypes.bool,
  closeAddJobsToModel: PropTypes.func,
  showSlideout: PropTypes.func,
  getJobRangeModelData: PropTypes.func,
  modelJobs: PropTypes.array,
  modelJobsLoading: PropTypes.bool,
  modelNameBlur: PropTypes.func,
  clearModelDetails: PropTypes.func,
  jobRangeModel: PropTypes.object,
  createNewRangeModel: PropTypes.func,
  payTypeChange: PropTypes.func,
  payTypeOptions: PropTypes.array,
  currencies: PropTypes.array,
  currencyChange: PropTypes.func,
  currentCurrency: PropTypes.object,
  match: PropTypes.object,
  moveToCurrent: PropTypes.func,
  moveToCurrentLoading: PropTypes.bool,
  summaryVisible: PropTypes.bool,
  history: PropTypes.object,
  userReadOnly: PropTypes.bool,
  loadRangeTypeOptions: PropTypes.func,
  isLab: PropTypes.bool
};

class ModelDetailsPage extends Component {
  static propTypes = propTypes;

  static contextType = ReactReduxContext;

  constructor(props) {
    super(props);
    this.state = {
      confirmModalViz: false,
      isEditingName: false, 
      modelJobsSearchTerm: '',
    };

    this.handleCurrencyChange = this.handleCurrencyChange.bind(this);
    this.onModelNameEdit = this.onModelNameEdit.bind(this);
    this.onModelNameBlur = this.onModelNameBlur.bind(this);
    this.handleSortChange = this.handleSortChange.bind(this);
    this.setSearch = this.setSearch.bind(this);
    this.searchJobs = this.searchJobs.bind(this);
    this.pageJobs = this.pageJobs.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
  }

  componentDidMount() {
    const {
      createNewRangeModel,
      getJobRangeModelData,
      history,
      isLab,
      jobRangeModels,
      loadRangeTypeOptions,
      match
    } = this.props;

    const ids = jobRangeModels.map(model => model.jobRangeModelId);
    const modelId = match.params.modelId;

    if (modelId !== 'add' && !ids.includes(parseInt(modelId))) {
      history.push('/ranges');
    } else {
      loadRangeTypeOptions();
      if (modelId === 'add') createNewRangeModel(isLab, history);
      else if (modelId) getJobRangeModelData(modelId);
    }

    this.props.setSelectedSort(''); // Reset sort bar upon mounting
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.selectedSort.sortColumn !== this.props.selectedSort.sortColumn ||
      prevProps.selectedSort.sortOrder !== this.props.selectedSort.sortOrder
    ) {
      this.pageJobs();
    }
  }

  handleSortChange(option) {
    this.props.setSelectedSort(option);
    console.log('selectedSort: ', this.props.selectedSort);
  }

  handleCurrencyChange(event) {
    const { currencies, currencyChange } = this.props;
    const selectedCurrency = currencies.find(curr => curr.name === event) || {
      id: null,
      name: 'All Currencies',
      code: '%'
    };

    currencyChange(selectedCurrency);
  }

  onModelNameEdit() {
    this.setState({
      isEditingName: true
    });
  }

  onModelNameBlur(event) {
    this.props.modelNameBlur(event);
    this.setState({ isEditingName: false });
  }

  modelNameContent() {
    if (this.state.isEditingName) {
      return (
        <h2 className="jobRanges__modelNameContainer">
          <TextInputMP
            onChange={this.props.onNameInputChange}
            value={this.props.nameInputValue}
            className="jobRanges__modelName--edit"
            autoFocus={true}
            onBlur={this.onModelNameBlur}
          />
        </h2>
      );
    } else {
      let editButton = null;
      if (this.props.userReadOnly === false) {
        editButton = (
          <i
            className="icon-edit-model-name icon-pencil"
            onClick={this.onModelNameEdit}
            data-test-id="jbr-model-change-name-button"
          />
        );
      }

      return (
        <h2 className="jobRanges__modelNameContainer jobRanges__modelName">
          {this.props.nameInputValue}
          {editButton}
        </h2>
      );
    }
  }

  currency() {
    const { currencies, currentCurrency, history, jobRangeModel, modelJobs, userReadOnly } = this.props;
    const currencyId = jobRangeModel && jobRangeModel.currencyId;
    const jobCount = modelJobs.length;
    const selectedCurrency = currencies.find(curr => curr.id === currencyId) || {
      id: null,
      name: 'All Currencies',
      code: '%'
    };
    const defaultCurrencyOption = { value: selectedCurrency.id, name: selectedCurrency.name };

    const CurrSelect = (
      <Dropdown
        className="job-ranges__dropdown"
        text={defaultCurrencyOption.name}
        dropdownItems={currencies.map(curr => curr.name)}
        itemOnClick={this.handleCurrencyChange}
      />
    );

    if (!jobRangeModel) return CurrSelect;
    if (currentCurrency.id !== selectedCurrency.id && currentCurrency.id !== null && selectedCurrency.id !== null) {
      history.push('/ranges');
    }

    if (currentCurrency.id === null && !jobCount && userReadOnly !== true) {
      return CurrSelect;
    } else {
      return <div className="jobRanges__currentPayContent">{defaultCurrencyOption.name}</div>;
    }
  }

  renderActionButtonContainerContent() {
    if (this.props.userReadOnly === false) {
      return (
        <div className="action-container">
          <div className="action-row">
            <div className="action-dropdown">
              <h5 className="heading--statMain">Currency</h5>
              {this.currency()}
            </div>
            <div className="action-dropdown">
              <h5 className="heading--statMain">Pay Type</h5>
              {this.renderPayTypeOptionComponent()}
            </div>
          </div>
          <div className="action-row">
            <div
              className="pointer edit-jobs"
              onClick={() => this.props.showSlideout(SLIDEOUTS.JOB_RANGES_SLIDEOUT)}
              data-test-id="jbr-edit-model-jobs-button"
            >
              Edit Jobs in Model
            </div>
            <button
              data-test-id="jbr-move-current-button"
              className="pxl-btn pxl-btn-primary"
              onClick={() => this.setState({ confirmModalViz: true })}
            >
              Move to Current
            </button>
          </div>
        </div>
      );
    } else return null;
  }

  renderPayTypeOptionComponent() {
    const { jobRangeModel, payTypeChange, payTypeOptions, userReadOnly } = this.props;
    const payType = capitalize(jobRangeModel?.payType);
    const defaultPayTypeOption = payTypeOptions?.find(option => option.name === payType) || payTypeOptions[0];

    if (userReadOnly === false) {
      return (
        <Dropdown
          className="job-ranges__dropdown"
          dropdownItems={payTypeOptions.map(option => option.name)}
          itemOnClick={payTypeChange}
          text={defaultPayTypeOption?.name}
        />
      );
    } else {
      if (defaultPayTypeOption) {
        return <div className="jobRanges__currentPayContent">{defaultPayTypeOption.name}</div>;
      }
    }
  }

  renderExpandableHeader() {
    if (this.props.userReadOnly === false) {
      return (
        <ExpandableHeader toggle={this.props.toggleEditJobRangesModel} isExpanded={this.props.showEditJobRangeModel} />
      );
    } else {
      return <ExpandableHeader isExpandable={false} isExpanded={false} />;
    }
  }

  formatHeaderData() {
    const data = [
      { title: 'Label' },
      { title: 'Jobs' },
      { title: 'Employees' },
      { title: 'EEs Below Min' },
      { title: 'EEs Above Max' },
      { title: 'Cost to Min' },
      { title: 'Amount Above Max' },
      { title: 'Avg Compa Ratio' },
      { title: 'Avg Position in Range' }
    ];

    return data.map((el, idx) => {
      return (
        <div key={idx} style={{ width: el.width }}>
          {el.title}
        </div>
      );
    });
  }

  hasProposedValues() {
    const { jobRangeModel } = this.props;
    return (
      !jobRangeModel?.proposedEmployeesBelowMin &&
      !jobRangeModel?.proposedEmployeesAboveMax &&
      !jobRangeModel?.proposedEmployeesAboveMax &&
      !jobRangeModel?.proposedCostToMin
    );
  }
  formatFooterData() {
    const { jobRangeModel, preferences } = this.props;
    const hideProposedRow = this.hasProposedValues();

    return [
      <span className="jbr__analytics-data" key={0}>
        <span className="current-text">Current</span>
        <span className={classnames('proposed-text', { 'datapoint-hidden': hideProposedRow })}>Proposed</span>
      </span>,
      <span className="jbr__analytics-data" key={1}>
        <span className="current-text">{jobRangeModel?.jobCount ? numberWithCommas(jobRangeModel.jobCount) : 0}</span>
        <span className="proposed-text datapoint-hidden">-</span>
      </span>,
      <span className="jbr__analytics-data" key={2}>
        <span className="current-text">
          {jobRangeModel?.employeeCount ? numberWithCommas(jobRangeModel.employeeCount) : 0}
        </span>
        <span className="proposed-text datapoint-hidden">-</span>
      </span>,
      <span className="jbr__analytics-data" key={3}>
        <span className="current-text">
          {jobRangeModel?.currentEmployeesBelowMin ? numberWithCommas(jobRangeModel.currentEmployeesBelowMin) : '-'}
        </span>
        <span className={classnames('proposed-text', { 'datapoint-hidden': hideProposedRow })}>
          {jobRangeModel?.proposedEmployeesBelowMin ? numberWithCommas(jobRangeModel.proposedEmployeesBelowMin) : '-'}
        </span>
      </span>,
      <span className="jbr__analytics-data" key={4}>
        <span className="current-text">
          {jobRangeModel?.currentEmployeesAboveMax ? numberWithCommas(jobRangeModel.currentEmployeesAboveMax) : '-'}
        </span>
        <span className={classnames('proposed-text', { 'datapoint-hidden': hideProposedRow })}>
          {jobRangeModel?.proposedEmployeesAboveMax ? numberWithCommas(jobRangeModel.proposedEmployeesAboveMax) : '-'}
        </span>
      </span>,
      <span className="jbr__analytics-data" key={5}>
        <span className="current-text">
          {parseNumCheckNull(applyRounding(jobRangeModel?.currentCostToMin, 'monetary', preferences))}
        </span>
        <span className={classnames('proposed-text', { 'datapoint-hidden': hideProposedRow })}>
          {parseNumCheckNull(applyRounding(jobRangeModel?.proposedCostToMin, 'monetary', preferences))}
        </span>
      </span>,
      <span className="jbr__analytics-data" key={6}>
        <span className="current-text">
          {parseNumCheckNull(applyRounding(jobRangeModel?.currentCostToMax, 'monetary', preferences))}
        </span>
        <span className={classnames('proposed-text', { 'datapoint-hidden': hideProposedRow })}>
          {parseNumCheckNull(applyRounding(jobRangeModel?.proposedCostToMax, 'monetary', preferences))}
        </span>
      </span>,
      <span className="jbr__analytics-data" key={6}>
        <span className="current-text">
          {applyRounding(jobRangeModel?.currentAvgCompRatio * 100, 'percent', preferences) || '-'}
        </span>
        <span className={classnames('proposed-text', { 'datapoint-hidden': hideProposedRow })}>
          {applyRounding(jobRangeModel?.proposedAvgCompRatio * 100, 'percent', preferences) || '-'}
        </span>
      </span>,
      <span className="jbr__analytics-data" key={6}>
        <span className="current-text">
          {applyRounding(jobRangeModel?.currentAvgRangePen * 100, 'percent', preferences) || '-'}
        </span>
        <span className={classnames('proposed-text', { 'datapoint-hidden': hideProposedRow })}>
          {applyRounding(jobRangeModel?.proposedAvgRangePen * 100, 'percent', preferences) || '-'}
        </span>
      </span>
    ];
  }

  renderCostAnalysis() {
    const hideProposedRow = this.hasProposedValues();

    return (
      <div className={classnames('jbr__analytics', { 'single__row-bar': hideProposedRow })}>
        <TableInfoList
          tableClass="jbr__analytics-table"
          headerClass="jbr__analytics-header"
          cellClass="jbr__analytics-cell"
          headers={this.formatHeaderData()}
          data={this.formatFooterData()}
        />
      </div>
    );
  }

  setSearch(e) {
    const { setSearch } = this.props;

    setSearch(e.target.value);
  }

  searchJobs(e) {
    const { searchModelJobs } = this.props;

    if (e.key === 'Enter') {
      searchModelJobs(e.target.value);
    }
  }

  pageJobs(limit, offset) {
    const { modelJobsSearchTerm, showMoreJobs, modelJobsLimit, selectedSort } = this.props;
    const { sortColumn, sortOrder } = selectedSort;
    const searchTerm = modelJobsSearchTerm || '';

    const data = {
      limit: isNaN(limit) ? modelJobsLimit : limit,
      offset: offset || 0,
      searchTerm,
      sortColumn,
      sortOrder
    };
  
    showMoreJobs(data);
  }

  clearSearch(limit, offset) {
    const { showMoreJobs, modelJobsLimit, selectedSort, setSearch } = this.props;
    const { sortColumn, sortOrder } = selectedSort;

    setSearch('');

    const data = {
      limit: isNaN(limit) ? modelJobsLimit : limit,
      offset: offset || 0,
      searchTerm: '',
      sortColumn,
      sortOrder
    };
  
    showMoreJobs(data);
  }

  render() {
    const { props } = this;
    const totalCount = props.filterApplied ? props.totalFilteredJobs : props?.selectedJobs?.length;

    return (
      <React.Fragment>
        <div className="jobRanges">
          <div className="jobRanges__header">
            <div className="inputs-container">
              <Link className="pointer back-to-models-link" to="/ranges" data-test-id="jbr-back-model-list-button">
                <i className="icon-left" />
                Back to Models
              </Link>
              {this.modelNameContent()}
            </div>
            {this.renderActionButtonContainerContent()}
          </div>
          {this.renderExpandableHeader()}
          <div
            className={classnames('jobRanges__sliderContent', {
              lab: props.isLab,
              open: props.showEditJobRangeModel,
              'modified__header-single': props.jobRangeModel.buildMinMaxBy === BUILD_BY_PERCENTAGE,
              'modified__header-double':
                props.jobRangeModel.buildMinMaxBy === BUILD_BY_PERCENTAGE &&
                props.jobRangeModel.rangeType === MARKET_RANGE_TYPE
            })}
          >
            {props.filteredModelJobs.length > 0 && this.renderCostAnalysis()}
            <div className="job__ranges-table-container">
              <div className="jobListView">
              <React.Fragment>
                <div className="search-and-sort-container">
                  <Search
                    className="model__jobs-search"
                    onChange={this.setSearch}
                    onKeyDown={this.searchJobs}
                    onClick={this.clearSearch}
                    placeholder="Search by job title, job code, job code key, or job family"
                    value={props.modelJobsSearchTerm}
                  />
                    <label className="job__ranges-sort-label" htmlFor="job-ranges">
                      Sort by
                    </label>
                    <div className="job__ranges-sort-wrapper">
                      <Select
                        className="job__ranges-sort"
                        handleChange={this.handleSortChange}
                        id="job__ranges-sort"
                        options={SORT_OPTIONS}
                        value={this.props.selectedSort.name}
                      />
                    </div>
                  </div>
                </React.Fragment>
                <ModelJobsList
                  pageJobs={this.pageJobs}
                  replacementTokens={props.replacementTokens}
                  useJobCodeKey={props.useJobCodeKey}
                />
              </div>
              <div className="payRangeView">
                <RangeChartList
                  model={this.props.jobRangeModel}
                  modelJobs={props.filteredModelJobs}
                  preferences={this.props.preferences}
                  {...this.props.jobRangeModel}
                />
              </div>
              <LoadingIndicator loading={this.props.modelJobsLoading} />
            </div>
          </div>
          <ConfirmModal
            visible={this.state.confirmModalViz}
            onClickAway={() => this.setState({ confirmModalViz: false })}
            onConfirm={props.moveToCurrent}
          />
          <LoadingIndicator loading={this.props.moveToCurrentLoading} />
          <FooterStatsBar
            visible={this.props.summaryVisible}
            isNavOpen={window.localStorage.getItem('navcollapsed') === 'false'}
          />
        </div>
        {totalCount > props.modelJobsLimit && (
          <Pagination
            className="job__list-pagination"
            offset={props.modelJobsOffset}
            pageAction={this.pageJobs}
            step={props.modelJobsLimit}
            totalCount={totalCount}
          />
        )}
      </React.Fragment>
    );
  }
}

ModelDetailsPage.propTypes = propTypes;

const connectState = state => ({
  ...state.jobRanges.jobRanges,
  ...state.jobRanges.modelDetails,
  ...state.jobRanges.moveToCurrentStats,
  preferences: state?.session?.user?.preferences,
  selectedJobs: state.jobRanges.addJobsList.selectedJobsSnapshot,
  currencies: getCurrencies(state),
  currentCurrency: getSessionCurrency(state),
  userReadOnly: getIsUserReadOnly(state),
  useJobCodeKey: getUseJobCodeKey(state),
  replacementTokens: getReplacementTokens(state)
});

const actions = { 
  ...jobRangeActions, 
  showSlideout,
  setSelectedSort,
  updateFilteredModelJobs
 };

export default connect(connectState, actions)(ModelDetailsPage);
